import React from 'react';

import { BodyText, ContentSpace, TitleText } from './styledComponents';

export const AnsweringServiceInactiveContent = () => (
  <ContentSpace size="middle" direction="vertical">
    <TitleText>
      The live concierge service is inactive for this listing
    </TitleText>

    <BodyText>
      Any past or future appointments (if applicable) for this listing will not
      be accessed by the live concierge service. The live concierge service will
      not be able to find or take any action on this listing.
    </BodyText>
  </ContentSpace>
);
